import { makeStyles } from "@material-ui/core";
import backgroundImage from "../images/architecture-1869211_1920.png";

export default makeStyles((_) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "center",
    background: `url(${backgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  card: {
    padding: "2em",
    background: "rgba(240, 240, 255, 0.8)",
    backdropFilter: "blur(3px)",
    color: "rgba(0, 0, 0, 0.87)",
  },
  cardNew: {
    padding: "2em",
    background: "rgba(255, 255, 255, 0.95)",
    color: "rgba(0, 0, 0, 0.87)",
    borderRadius: "4px",
    boxShadow:
      "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
  },
}));
